import ftApiClient from "./ftApiClient";
import {
    ICustomerDetail,
    ICustomerInfo,
    ISetCustomerData,
    IQuote,
    IAddItemToNewQuote,
    IAddItemToExistingQuote,
    IUpdateCartItemData,
} from "@interfaces";
import { IAPIResult } from "src/Interfaces/api";
import { buildQuoteRemoveUrl, RemovePayloadCart } from "@utilities";

export const quoteApi = {
    newQuote: (params: IAddItemToNewQuote) => {
        const url = "/quotes/new/v2";
        return ftApiClient.post(url, params);
    },
    getQuotes: () => {
        const url = "/quotes";
        return ftApiClient.get<IAPIResult<IQuote[]>>(url);
    },
    getQuoteDetails: (quoteId: number | string) => {
        const url = `/quotes/${quoteId}`;
        return ftApiClient.get<IAPIResult<IQuote>>(url);
    },
    deleteQuote: (quoteId: number | string) => {
        const url = `quotes/${quoteId}`;
        return ftApiClient.delete(url);
    },
    addQuoteItem: (quoteId: string, itemData: IAddItemToExistingQuote) => {
        const url = `/quotes/${quoteId}/items/add/v2`;
        return ftApiClient.put(url, itemData);
    },
    updateQuoteItem: (params: IUpdateCartItemData[], quoteId: number | string) => {
        const url = `cart/items/v2?quoteId=${quoteId}`;
        return ftApiClient.put(url, params);
    },
    updateQuoteItems: (params: IUpdateCartItemData[], quoteId: number | string) => {
        const url = `cart/items/v2?quoteId=${quoteId}`;
        return ftApiClient.put(url, params);
    },
    deleteQuoteItem: (payload: RemovePayloadCart, quoteId: string | number) => {
        const url = buildQuoteRemoveUrl(payload, quoteId);
        return ftApiClient.delete(url);
    },
    setCustomers: (quoteId: number | string, params: ICustomerInfo[]) => {
        const url = `cart/redeemers?quoteId=${quoteId}`;
        return ftApiClient.put(url, params);
    },
    addCustomers: (quoteId: number | string, params: ISetCustomerData) => {
        const url = `cart/redeemers?quoteId=${quoteId}`;
        return ftApiClient.post(url, params);
    },
    getCustomers: (quoteItemId: number | string) => {
        const url = `cart/redeemers?quoteId=${quoteItemId}`;
        return ftApiClient.get<IAPIResult<ICustomerDetail[]>>(url);
    },
    createOrder: (quoteId: string) => {
        const url = `quotes/${quoteId}/order`;
        return ftApiClient.post(url);
    },
};
